<template>
    <div id="modal" class="modal shareHouseModal" v-if="display">
        <div class="modal-content">
            <div class="cancle" @click="modalClose">
                <img src="@/assets/img/shareHouse/cross.svg" alt="">
            </div>
            <div class="detail">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Modal',
    data () {
        return {
            openStatus: this.display,   
        }
    },
    props: {
        display: Boolean
    },
    watch: {
        display (val) {
            this.openStatus = val
        }
    },    
    methods: {
        modalClose: function (id) {
            // var elem = document.getElementById(id)
            // elem.style.display = 'none';
            this.$emit('modalStatus', false);
        },
    }
}
</script>
<style   lang="scss">
    #modal.shareHouseModal{
        position: fixed; /* Stay in place */
        z-index: 999; /* Sit on top */
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        -webkit-backdrop-filter: blur(0.5px);
        backdrop-filter: blur(0.5px);
        background-color: rgba(0, 0, 0, 0.6);
        .modal-content {
            position: relative;
            margin: auto;
            padding: 30px 32px;
            border-radius: 8px;
            background-color: #ffffff;
            box-shadow: 0 4px 16px 0 rgba(144, 144, 144, 0.5);
            .cancle{
                position: absolute;
                cursor: pointer;
                top: 32px;
                right: 32px;
                z-index: 5;
            }
            .detail{
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }
    }
    @media (max-width: 992px) {
        #modal{
            .modal-content {
                .cancle{
                    position: absolute;
                    cursor: pointer;
                    top: 18px;
                    right: 18px;
                    z-index: 5;
                    img{
                        width: 10px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/ModalShareHouse.vue